var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataRegistrars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9340_15978)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_9340_15978)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7517 15.1949C13.7517 13.4872 15.1809 12.1416 16.8954 12.1416C18.6099 12.1416 20.0391 13.4872 20.0391 15.1949C20.0391 16.9025 18.6099 18.2481 16.8954 18.2481C15.1809 18.2481 13.7517 16.9025 13.7517 15.1949ZM16.8954 13.3916C15.8278 13.3916 15.0017 14.2203 15.0017 15.1949C15.0017 16.1694 15.8278 16.9981 16.8954 16.9981C17.963 16.9981 18.7891 16.1694 18.7891 15.1949C18.7891 14.2203 17.963 13.3916 16.8954 13.3916ZM13.3694 21.1628C13.1364 21.1628 12.9869 21.3392 12.9869 21.5091V26.8513C12.9869 28.8987 14.7151 30.5971 16.8956 30.5971C17.2408 30.5971 17.5206 30.877 17.5206 31.2221C17.5206 31.5673 17.2408 31.8471 16.8956 31.8471C14.0682 31.8471 11.7369 29.6318 11.7369 26.8513V21.5091C11.7369 20.6061 12.4895 19.9128 13.3694 19.9128H21.4293C21.7745 19.9128 22.0543 20.1926 22.0543 20.5378C22.0543 20.883 21.7745 21.1628 21.4293 21.1628H13.3694ZM27.3129 19.8961C27.1957 19.7789 27.0058 19.7789 26.8886 19.8961L23.5725 23.2122C23.4554 23.3293 23.4554 23.5193 23.5725 23.6364L25.0376 25.1016C25.1548 25.2187 25.3447 25.2187 25.4619 25.1016L28.778 21.7854C28.8952 21.6683 28.8952 21.4783 28.778 21.3612L27.3129 19.8961ZM26.0048 19.0122C26.6101 18.4069 27.5915 18.4069 28.1968 19.0122L29.6619 20.4773C30.2672 21.0826 30.2672 22.064 29.6619 22.6693L28.4507 23.8805L32.1733 27.6031C32.4174 27.8472 32.4174 28.2429 32.1733 28.487C31.9292 28.7311 31.5335 28.7311 31.2894 28.487L27.5668 24.7644L26.3458 25.9854C25.7405 26.5907 24.7591 26.5907 24.1538 25.9854L22.6886 24.5203C22.0833 23.915 22.0833 22.9336 22.6886 22.3283L26.0048 19.0122ZM20.1154 28.8311C20.1154 28.2098 20.6191 27.7061 21.2404 27.7061H27.4378C28.0591 27.7061 28.5628 28.2098 28.5628 28.8311V30.6087H29.0988C29.444 30.6087 29.7238 30.8885 29.7238 31.2337C29.7238 31.5788 29.444 31.8587 29.0988 31.8587H27.9378H20.7404H19.5794C19.2342 31.8587 18.9544 31.5788 18.9544 31.2337C18.9544 30.8885 19.2342 30.6087 19.5794 30.6087H20.1154V28.8311ZM21.3654 30.6087H27.3128V28.9561H21.3654V30.6087Z",
    fill: "#1B202C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9340_15978",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9340_15978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataRegistrars);
export default __webpack_public_path__ + "static/media/data-registrars.d289b901a46cd3d966cc7d26e5833407.svg";
export { ForwardRef as ReactComponent };